import React, { type PropsWithChildren } from "react";

import { useAuthenticateConnectedUser, useIsLoggedIn } from "@dynamic-labs/sdk-react-core";
import { SupLock } from "@repo/core-ui";
import { SupButton } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";
import Web3Account from "@/components/Web3/Account";

interface Web3CommonAuthenticateProps {
  className?: string;
  connectOnly?: boolean;
}
export default function Web3CommonAuthenticate({ className, connectOnly = false, children = "Authenticate" }: PropsWithChildren<Web3CommonAuthenticateProps>) {
  const { authenticateUser, isAuthenticating } = useAuthenticateConnectedUser();
  const isLoggedIn = useIsLoggedIn();

  const composedClassName = twMerge("w-full justify-center", className);

  return isLoggedIn ? (
    !connectOnly ? (
      <SupButton prefixIcon={<SupLock className="h-6 w-6" />} className={composedClassName} onClick={authenticateUser} disabled={isAuthenticating}>
        {children}
      </SupButton>
    ) : undefined
  ) : (
    <Web3Account className={composedClassName} />
  );
}
